<div class="content" mat-dialog-content>
  <mat-icon class="close" (click)="close()">close</mat-icon>
  <p #content></p>
</div>
<div class="buttons">
  <button mat-button class="button" (click)="onButton()">{{items[index].button}}</button>
</div>

